import React, { useState, useMemo } from "react";
import { createUniqueKey } from "../../utils";
import Dropdown, { MenuItem } from "../Dropdown";
import Icon, { ICON_TYPE_ACTION } from "../Icon";
import { LinkProps, To } from "react-router-dom";

export type NavigationProps =  Omit<LinkProps, 'to'> & {
    to?: To & { pathname?: string; };
    link?: To;
    title?: string;
    active?: boolean;
    hasChanges?: boolean;
    name?: string;
};

export type HeaderNavigationWithSubmenu = NavigationProps &
    {
        submenu: NavigationProps[];
    }[];

type HeaderNavigationDropdownProps = {
    navigation?: HeaderNavigationWithSubmenu[];
    labelMore: string;
    renderLink: (item: HeaderNavigationWithSubmenu) => void;
    title?: string;
};

function HeaderNavigationDropdown(props: HeaderNavigationDropdownProps) {
    const { labelMore, navigation = [], renderLink, title = "" } = props;
    const [visible, setVisible] = useState(false);

    const titleItem = useMemo(
        () =>
            title ? (
                <span role="button" tabIndex={0} className="hasSubmenu">
                    {title}
                </span>
            ) : (
                <Icon
                    role="button"
                    tabIndex={0}
                    type={ICON_TYPE_ACTION}
                    ariaLabel={labelMore}
                />
            ),
        [labelMore, title]
    );

    return (
        <Dropdown
            visible={visible}
            onVisibleChange={setVisible}
            placement="bottomRight"
            overlayClassName="Header-dropdown"
            title={titleItem}
        >
            {navigation.map((item, index) => (
                <MenuItem
                    key={createUniqueKey(index, item.title)}
                    onClick={() => setVisible(false)}
                >
                    {renderLink(item)}
                </MenuItem>
            ))}
        </Dropdown>
    );
}

export default HeaderNavigationDropdown;
